var $window = $(window);
var breakPoint = 767;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

// メディアクエリ
var mql = window.matchMedia('screen and (max-width: 1024px)');

//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

// Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

//ページ内リンクのアニメーション
import {currentNavi} from "../include/module";
currentNavi();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();



// WEBPACK FOOTER //
// ./src/larx/assets/js/error/script.js